import footerImg from "@/assets/footer-acelera.png";

const SECTIONS = [
  { label: "Formulário", href: "#formulario" },
  { label: "Estrutura", href: "#estrutura" },
  { label: "Diferencial", href: "#diferencial" },
  { label: "Método", href: "#metodo" },
  { label: "FAQ", href: "#faq" },
];

export default function FooterSection() {
  return (
    <footer
      className="footer-section"
      style={{ backgroundImage: `url(${footerImg})` }}
    >
      <div className="footer-overlay" />
      <div className="footer-noise-overlay" aria-hidden="true" />
      <div className="footer-dot-overlay" aria-hidden="true" />
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-socials">
            <a
              href="https://www.instagram.com/aceleramaisbr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="footer-social"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1"/></svg>
            </a>
          </div>
        </div>

        <div className="footer-sections">
          <h4>Seções</h4>
          <nav className="footer-sections-row">
            {SECTIONS.map((s) => (
              <a key={s.href} href={s.href}>{s.label}</a>
            ))}
          </nav>
        </div>
      </div>
      <div className="footer-copyright">
        Copyright 2026 © ACELERA MAIS <a href="#" className="footer-privacy">Política de Privacidade</a>
      </div>
    </footer>
  );
}
